/**
 * Centralized configuration for all plan purchase links
 * Edit these URLs in one place to update them across the entire application
 */

export const PLAN_LINKS = {
  // Monthly Plan
  MONTHLY: "https://buy.stripe.com/8x26oGby15u82PAgSafYY03", // Replace with actual monthly plan link

  // Annual Plan (currently the main link being used)
  ANNUAL: "https://buy.stripe.com/5kQ28qgSl09O3TE7hAfYY02",

  // Premium Plan
  PREMIUM: "https://buy.stripe.com/00weVcdG9bSwgGqeK2fYY01", // Replace with actual premium plan link



  // Stripe Customer Portal (for managing subscriptions)
  CUSTOMER_PORTAL: "https://billing.stripe.com/p/login/fZubJ059DbSweyiatMfYY00",
} as const;

/**
 * Helper function to get plan link by plan type
 */
export type PlanType = keyof typeof PLAN_LINKS;

export function getPlanLink(planType: PlanType): string {
  return PLAN_LINKS[planType];
}

/**
 * Common link attributes for external payment links
 */
export const PLAN_LINK_ATTRIBUTES = {
  target: "_blank" as const,
  rel: "noopener noreferrer" as const,
};
